import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import emailMask from 'text-mask-addons/dist/emailMask';
import filters from 'aurora-utils/filters.json';
import FILTERS_NAMES from 'aurora-utils/filtersNames';
import { numberMaskWithoutDecimalOption } from 'aurora-utils/constants';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import toString from 'lodash/toString';
import moment from 'moment';

export const SIDEBAR_FILTERS_LENGTH = 5;
export const SEARCH_FIELD_KEY = 'SEARCH_FIELD_KEY';
export const REQUIRED_PROFESSION_TYPES_FOR_OWNER_TYPE = ['Broker', 'Evaluator', 'Auctioneer', 'Surveying'];

export const DEPENDENT_FILTERS = {
  [FILTERS_NAMES.AUTHORIZATION]: FILTERS_NAMES.POA_OWNERS,
  // [FILTERS_NAMES.MUNICIPALITY]: FILTERS_NAMES.DISTRICT,
  [FILTERS_NAMES.DISTRICT]: FILTERS_NAMES.COMMUNITY,
  [FILTERS_NAMES.STATUS]: FILTERS_NAMES.PROGRESS_PERCENTAGE,
  [FILTERS_NAMES.PROFESSION_TYPE]: FILTERS_NAMES.OWNER_TYPE,
  [FILTERS_NAMES.FROM_DATE]: FILTERS_NAMES.TO_DATE,
  [FILTERS_NAMES.APPLICATION_START_DATE]: FILTERS_NAMES.APPLICATION_END_DATE,
};

export const FILTERS_WITH_FILTERED_OPTIONS = {
  // [FILTERS_NAMES.MUNICIPALITY]: {
  //   childFilter: FILTERS_NAMES.DISTRICT,
  //   filteringKey: 'municipalityID',
  // },
  [FILTERS_NAMES.DISTRICT]: {
    childFilter: FILTERS_NAMES.COMMUNITY,
    filteringKey: 'districtID',
  },
};

export const FULL_WIDTH_FILTERS = [FILTERS_NAMES.POA_OWNERS, FILTERS_NAMES.APPLICATION_ID];

export const FIELD_TYPES = {
  RADIO: 'radio',
  SELECT: 'select',
  FIELD: 'field',
  DATE: 'date',
};

export const FILTERS_DATA = {
  [FILTERS_NAMES.AUTHORIZATION]: {
    type: FIELD_TYPES.RADIO,
    label: 'authorizations',
    dropDownName: 'ownershipPoaProperty',
  },
  [FILTERS_NAMES.CERTIFICATE_TYPE]: {
    type: FIELD_TYPES.RADIO,
    label: 'certificate_type',
    dropDownName: 'workflowId',
  },
  [FILTERS_NAMES.PROPERTY_CERTIFICATE_NO]: {
    type: FIELD_TYPES.FIELD,
    label: 'property_certificate_no',
    dropDownName: 'certificateNo',
  },

  [FILTERS_NAMES.CERTIFICATE_TYPE_V2]: {
    type: FIELD_TYPES.SELECT,
    label: 'certificate_type',
    dropDownName: FILTERS_NAMES.CERTIFICATE_TYPE_V2,
  },
  [FILTERS_NAMES.CERTIFICATE_TYPE_LAND]: {
    type: FIELD_TYPES.SELECT,
    label: 'certificate_type',
    dropDownName: FILTERS_NAMES.CERTIFICATE_TYPE_LAND,
    required: true,
  },
  [FILTERS_NAMES.CERTIFICATE_TYPE_UNIT]: {
    type: FIELD_TYPES.SELECT,
    label: 'certificate_type',
    dropDownName: FILTERS_NAMES.CERTIFICATE_TYPE_UNIT,
    required: true,
  },
  [FILTERS_NAMES.CERTIFICATE_TYPE_LAND_BROKER]: {
    type: FIELD_TYPES.SELECT,
    label: 'certificate_type',
    dropDownName: FILTERS_NAMES.CERTIFICATE_TYPE_LAND_BROKER,
    required: true,
  },
  [FILTERS_NAMES.CERTIFICATE_TYPE_UNIT_BROKER]: {
    type: FIELD_TYPES.SELECT,
    label: 'certificate_type',
    dropDownName: FILTERS_NAMES.CERTIFICATE_TYPE_UNIT_BROKER,
    required: true,
  },
  [FILTERS_NAMES.CERTIFICATE_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'certificate_number',
  },
  [FILTERS_NAMES.CERTIFICATE_NUMBER_PERMIT]: {
    type: FIELD_TYPES.FIELD,
    label: 'certificate_number',
    required: true,
  },
  [FILTERS_NAMES.CERTIFICATE_DATE]: {
    type: FIELD_TYPES.DATE,
    label: 'certificate_date',
  },
  [FILTERS_NAMES.POA_OWNERS]: {
    type: FIELD_TYPES.SELECT,
    label: 'owners',
    // placeholder: 'Owners',
    dropDownName: 'poaCustomerIds',
    multi: true,
  },
  [FILTERS_NAMES.MUNICIPALITY]: {
    type: FIELD_TYPES.RADIO,
    label: 'municipality',
    dropDownName: 'municipality',
  },
  [FILTERS_NAMES.DISTRICT]: {
    type: FIELD_TYPES.SELECT,
    label: 'district',
    // placeholder: 'district',
    dropDownName: 'district',
  },
  [FILTERS_NAMES.COMMUNITY]: {
    type: FIELD_TYPES.SELECT,
    label: 'community',
    // placeholder: 'community',
    dropDownName: 'community',
  },
  [FILTERS_NAMES.PLOT_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'plot_number',
  },
  [FILTERS_NAMES.PLOT_ADDRESS]: {
    type: FIELD_TYPES.FIELD,
    label: 'plot_address',
    placeholder: 'plot_address',
  },
  [FILTERS_NAMES.IS_BLOCKED]: {
    type: FIELD_TYPES.RADIO,
    label: 'status',
    dropDownName: 'isBlocked',
  },
  [FILTERS_NAMES.PROJECT_STATUS]: {
    type: FIELD_TYPES.RADIO,
    label: 'project_status',
    dropDownName: 'projectStatus',
  },
  [FILTERS_NAMES.PROJECT_NAME]: {
    type: FIELD_TYPES.SELECT,
    label: 'project_name',
    // placeholder: 'project_name',
    dropDownName: FILTERS_NAMES.PROJECT_NAME,
  },
  [FILTERS_NAMES.PROJECT_NAME_MORTGAGE]: {
    type: FIELD_TYPES.SELECT,
    label: 'project_name',
    // placeholder: 'project_name',
    dropDownName: FILTERS_NAMES.PROJECT_NAME_MORTGAGE,
  },
  [FILTERS_NAMES.ALLOCATION_TYPE]: {
    type: FIELD_TYPES.SELECT,
    label: 'Allocation_type',
    // placeholder: 'Allocation_type',
    dropDownName: 'allocationType',
  },
  [FILTERS_NAMES.OWNERSHIP_TYPE_ID]: {
    type: FIELD_TYPES.RADIO,
    label: 'owner_type',
    dropDownName: 'ownerShipType',
  },
  [FILTERS_NAMES.ACQUISITION_TYPE]: {
    type: FIELD_TYPES.SELECT,
    label: 'acquisition_type',
    // placeholder: 'acquisition_type',
    dropDownName: 'acquisitionTypeId',
  },
  [FILTERS_NAMES.MORTGAGE_STATUS]: {
    type: FIELD_TYPES.RADIO,
    label: 'mortgage_status',
    dropDownName: 'mortgage',
  },
  [FILTERS_NAMES.RENT_STATUS]: {
    type: FIELD_TYPES.RADIO,
    label: 'rent_satus',
    dropDownName: 'rentStatus',
  },
  [FILTERS_NAMES.BUILDING_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'building_name_number',
  },
  [FILTERS_NAMES.BUILDING_NAME]: {
    type: FIELD_TYPES.FIELD,
    label: 'building_name',
  },
  [FILTERS_NAMES.UNIT_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'unit_number',
  },
  [FILTERS_NAMES.FLOOR_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'floor_number',
  },
  [FILTERS_NAMES.UNIT_USE]: {
    type: FIELD_TYPES.SELECT,
    label: 'unit_use',
    dropDownName: FILTERS_NAMES.UNIT_USE,
  },
  [FILTERS_NAMES.UNIT_TYPE]: {
    type: FIELD_TYPES.SELECT,
    label: 'unit_classification',
    dropDownName: 'unitType',
  },
  [FILTERS_NAMES.USE_TYPE]: {
    type: FIELD_TYPES.SELECT,
    label: 'use_type',
    // placeholder: 'unit_type',`
    dropDownName: FILTERS_NAMES.USE_TYPE,
  },
  [FILTERS_NAMES.MORTGAGE_TYPE]: {
    type: FIELD_TYPES.SELECT,
    label: 'mortgage_type',
    // placeholder: 'mortgage_type',
    dropDownName: 'mortgageType',
  },
  [FILTERS_NAMES.NO_OF_ROOMS]: {
    type: FIELD_TYPES.RADIO,
    label: 'number_of_rooms',
    dropDownName: 'bedrooms',
    shape: 'SQUARE',
  },
  [FILTERS_NAMES.BEDROOMS]: {
    type: FIELD_TYPES.RADIO,
    label: 'number_of_rooms',
    dropDownName: 'bedrooms',
    shape: 'SQUARE',
    multi: true,
  },
  [FILTERS_NAMES.PROPERTY_REG_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'property_reg_no_text',
    placeholder: 'property_reg_no_text_hint',
  },
  [FILTERS_NAMES.UNIT_REG_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'unt_reg_number',
    placeholder: 'enter_unit_registration_number',
  },
  [FILTERS_NAMES.PROJECT_ELMS_ID]: {
    type: FIELD_TYPES.FIELD,
    label: 'project_id',
  },
  [FILTERS_NAMES.LAND_USE]: {
    type: FIELD_TYPES.SELECT,
    label: 'Land_use',
    dropDownName: FILTERS_NAMES.LAND_USE,
  },

  // Contracts

  [FILTERS_NAMES.CONTRACT_ID]: {
    type: FIELD_TYPES.FIELD,
    label: 'contract_number',
    placeholder: 'property_reg_no_text_hint',
  },
  [FILTERS_NAMES.CONTRACT_CLASSIFICATION_TYPE]: {
    type: FIELD_TYPES.SELECT,
    label: 'contract_type',
    dropDownName: 'contractClassificationType',
  },
  [FILTERS_NAMES.CONTRACT_STATUS]: {
    type: FIELD_TYPES.SELECT,
    label: 'contract_status',
    dropDownName: 'contractStatus',
  },
  [FILTERS_NAMES.CONTRACT_CLASSIFICATION_ID]: {
    type: FIELD_TYPES.SELECT,
    label: 'pma_type_filter',
    // placeholder: 'pma_type_filter',
    dropDownName: FILTERS_NAMES.CONTRACT_CLASSIFICATION_ID,
  },
  [FILTERS_NAMES.FROM_DATE]: {
    type: FIELD_TYPES.DATE,
    label: 'contract_start_date',
    placeholder: 'start_date',
  },
  [FILTERS_NAMES.TO_DATE]: {
    type: FIELD_TYPES.DATE,
    label: 'contract_end_date',
    placeholder: 'end_date',
  },
  [FILTERS_NAMES.BUILDING_REG_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'building_registration_number_name',
    placeholder: 'building_registration_number_plc',
  },
  [FILTERS_NAMES.UNIT_ID]: {
    type: FIELD_TYPES.FIELD,
    label: 'unit_reg_number',
    placeholder: 'unit_reg_number_eg',
  },
  [FILTERS_NAMES.UNIT_NUMBER_OR_NAME]: {
    type: FIELD_TYPES.FIELD,
    label: 'unit_name_number',
    placeholder: 'property_reg_no_text_hint',
  },
  [FILTERS_NAMES.PREMISE_ID]: {
    type: FIELD_TYPES.FIELD,
    label: 'premise_number',
    placeholder: 'premise_number_plc',
  },
  [FILTERS_NAMES.TENANT_PHONE_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'tenant_phone_number',
    placeholder: 'mobile_number_hint',
  },
  [FILTERS_NAMES.TENANT_UNIFIED_EID_OR_TL_NUM]: {
    type: FIELD_TYPES.FIELD,
    label: 'tenant_id_license_number',
    placeholder: 'property_reg_no_text_hint',
  },
  [FILTERS_NAMES.TENANT_NAME]: {
    type: FIELD_TYPES.FIELD,
    label: 'tenant_name',
    placeholder: 'enter_tenant_name',
  },
  [FILTERS_NAMES.PMA_CLASSIFICATION]: {
    type: FIELD_TYPES.RADIO,
    label: 'pma_classification',
    dropDownName: 'pmaClassification',
  },
  [FILTERS_NAMES.DATE_OF_SALE]: {
    type: FIELD_TYPES.DATE,
    label: 'date_of_sale',
    placeholder: 'date_of_sale',
  },
  [FILTERS_NAMES.PAYMENT_STATUS]: {
    type: FIELD_TYPES.RADIO,
    label: 'paymentStatus',
    dropDownName: 'paymentStatus',
  },

  // Directory
  [FILTERS_NAMES.PROJECT_TYPE]: {
    type: FIELD_TYPES.SELECT,
    label: 'project_type',
    // placeholder: 'project_type',
    dropDownName: 'projectType',
    multi: true,
  },
  [FILTERS_NAMES.DEVELOPER_NAME]: {
    type: FIELD_TYPES.FIELD,
    label: 'developer_name',
  },
  [FILTERS_NAMES.BUILDING_USAGE]: {
    type: FIELD_TYPES.RADIO,
    label: 'building_usage',
    dropDownName: 'buildingUsage',
  },
  [FILTERS_NAMES.STATUS]: {
    type: FIELD_TYPES.RADIO,
    label: 'status',
    dropDownName: 'status',
  },
  [FILTERS_NAMES.PROGRESS_PERCENTAGE]: {
    type: FIELD_TYPES.RADIO,
    label: 'completion_percentage',
    dropDownName: 'progressPercentage',
  },
  [FILTERS_NAMES.PROFESSION_TYPE]: {
    type: FIELD_TYPES.SELECT,
    label: 'Profession',
    // placeholder: 'Profession',
    dropDownName: 'professionType',
  },
  [FILTERS_NAMES.OWNER_TYPE]: {
    type: FIELD_TYPES.RADIO,
    label: 'classification',
    dropDownName: 'ownerType',
  },

  // Applications & Tasks
  [FILTERS_NAMES.APPLICATION_ID]: {
    type: FIELD_TYPES.FIELD,
    label: 'Application_ID',
  },
  [FILTERS_NAMES.APPLICATION_STATUS]: {
    type: FIELD_TYPES.SELECT,
    label: 'application_status',
    placeholder: 'application_status',
    dropDownName: 'applicationStatuses',
  },
  [FILTERS_NAMES.APPLICATION_TYPE]: {
    type: FIELD_TYPES.SELECT,
    label: 'application_type',
    placeholder: 'application_type',
    dropDownName: FILTERS_NAMES.APPLICATION_TYPE,
  },
  [FILTERS_NAMES.INITIATOR_NAME]: {
    type: FIELD_TYPES.FIELD,
    label: 'initiator_name',
  },
  [FILTERS_NAMES.APPLICATION_START_DATE]: {
    type: FIELD_TYPES.DATE,
    label: 'creation_date_from',
  },
  [FILTERS_NAMES.APPLICATION_END_DATE]: {
    type: FIELD_TYPES.DATE,
    label: 'creation_date_to',
  },
  [FILTERS_NAMES.EID_OR_MOI_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'eid_un_no',
  },
  [FILTERS_NAMES.TRADE_LICENSE_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'trade_license_number',
  },
  [FILTERS_NAMES.APPLICATION_NAME]: {
    type: FIELD_TYPES.FIELD,
    label: 'Name',
  },
  [FILTERS_NAMES.PHONE_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'Phone_Number',
  },
  [FILTERS_NAMES.EMAIL]: {
    type: FIELD_TYPES.FIELD,
    label: 'email_address',
    placeholder: 'email_hint',
  },
  [FILTERS_NAMES.TASK_STATUS]: {
    type: FIELD_TYPES.SELECT,
    label: 'task_status',
    placeholder: 'task_status',
    dropDownName: 'taskStatuses',
  },
  // project listing
  [FILTERS_NAMES.PROJECT_NUMBER]: {
    type: FIELD_TYPES.FIELD,
    label: 'project_number',
    placeholder: 'project_number', // TODO :: Lokalise
  },
  // Surveyor Company
  [FILTERS_NAMES.SURVEYOR_NAME]: {
    type: FIELD_TYPES.FIELD,
    label: 'surveyor_name',
  },
  [FILTERS_NAMES.REGISTRATION_LICENSE_NO]: {
    type: FIELD_TYPES.FIELD,
    label: 'registration_license_no',
  },

  // Non UAE Users
  [FILTERS_NAMES.PASSPORT_NUM]: {
    type: FIELD_TYPES.FIELD,
    label: 'Passport_number',
    required: true,
  },
  [FILTERS_NAMES.NATIONALITY_ID]: {
    type: FIELD_TYPES.SELECT,
    label: 'nationality',
    dropDownName: FILTERS_NAMES.NATIONALITY_ID,
  },
  [FILTERS_NAMES.MOBILE_NO]: {
    type: FIELD_TYPES.FIELD,
    label: 'mobile',
  },
  // ROAD
  [FILTERS_NAMES.ROAD]: {
    type: FIELD_TYPES.FIELD,
    label: 'Road',
    placeholder: 'Road',
  },
};

export const getInitialState = requiredFilters => {
  return requiredFilters?.reduce((state, filterName) => {
    const { multi = false } = FILTERS_DATA[filterName];
    return {
      ...state,
      [filterName]: multi ? [] : null,
    };
  }, {});
};

export const getDropdownData = key => {
  const lang = localStorage.getItem('lang');
  return filters[key]?.map(item => ({
    value: item.value,
    label: lang === 'ar' ? item.labelAr : item.labelEn,
  }));
};

export const getFilteredDropdownData = (name, value, filterKey) => {
  const locale = localStorage.getItem('lang');
  if (!value) return [];
  const list = filters[name]
    .filter(data => {
      return toString(data[filterKey]) === toString(value);
    })
    .map(item => ({
      value: item.value,
      label: locale === 'ar' ? item.labelAr : item.labelEn,
    }));
  return list;
};

export const getFilterData = (filterName, formData, dropDowns) => {
  const { dropDownName = '', ...filterData } = FILTERS_DATA[filterName];

  filterData.value = formData[filterName];

  if (
    filterData?.type === FIELD_TYPES.RADIO ||
    filterData?.type === FIELD_TYPES.SELECT ||
    filterData?.type === FIELD_TYPES.FIELD
  ) {
    const dropDownList = isArray(dropDowns[dropDownName]) ? dropDowns[dropDownName] : [];
    filterData.options = dropDownList;
  }
  switch (filterName) {
    case FILTERS_NAMES.PROPERTY_CERTIFICATE_NO:
      const years = [];
      for (let i = 2020; i <= new Date().getFullYear(); i += 1) {
        years.push({ value: i, label: i });
      }
      filterData.options = years;
      filterData.required = true;
      filterData.mask = createNumberMask(numberMaskWithoutDecimalOption);
      break;
    case FILTERS_NAMES.CERTIFICATE_TYPE:
      filterData.required = true;
      break;
    case FILTERS_NAMES.POA_OWNERS:
      filterData.renderCondition = !isEmpty(filterData?.options) && formData[FILTERS_NAMES.AUTHORIZATION] === 2;
      break;
    case FILTERS_NAMES.DISTRICT:
      filterData.search = filterData?.options?.length > 10;
      // filterData.disabled = !formData[FILTERS_NAMES.MUNICIPALITY];
      break;
    case FILTERS_NAMES.COMMUNITY:
      filterData.search = filterData?.options?.length > 10;
      filterData.disabled = !formData[FILTERS_NAMES.DISTRICT];
      break;
    case FILTERS_NAMES.PROJECT_NAME:
      filterData.search = filterData?.options?.length > 10;
      break;
    case FILTERS_NAMES.PROJECT_NAME_MORTGAGE:
      filterData.search = filterData?.options?.length > 10;
      break;
    case FILTERS_NAMES.PROGRESS_PERCENTAGE:
      filterData.renderCondition = formData[FILTERS_NAMES.STATUS] === 'UNDER_CONSTRUCTION';
      break;
    case FILTERS_NAMES.OWNER_TYPE:
      filterData.renderCondition = REQUIRED_PROFESSION_TYPES_FOR_OWNER_TYPE.includes(
        formData[FILTERS_NAMES.PROFESSION_TYPE],
      );
      break;
    case FILTERS_NAMES.APPLICATION_ID:
    case FILTERS_NAMES.PHONE_NUMBER:
    case FILTERS_NAMES.EID_OR_MOI_NUMBER:
    case FILTERS_NAMES.PREMISE_ID:
    case FILTERS_NAMES.PROJECT_ELMS_ID:
    case FILTERS_NAMES.MOBILE_NO:
      filterData.mask = createNumberMask(numberMaskWithoutDecimalOption);
      break;
    case FILTERS_NAMES.EMAIL:
      filterData.mask = emailMask;
      break;
    case FILTERS_NAMES.TO_DATE:
      if (moment(formData[FILTERS_NAMES.FROM_DATE]).isValid()) {
        filterData.lowerLimit = moment(formData[FILTERS_NAMES.FROM_DATE], 'YYYY-MM-DD').format('YYYY-MM-DD');
      } else {
        filterData.disabled = true;
      }
      break;
    case FILTERS_NAMES.APPLICATION_END_DATE:
      if (moment(formData[FILTERS_NAMES.APPLICATION_START_DATE]).isValid()) {
        filterData.lowerLimit = moment(formData[FILTERS_NAMES.APPLICATION_START_DATE], 'YYYY-MM-DD').format(
          'YYYY-MM-DD',
        );
      } else {
        filterData.disabled = true;
      }
      break;
    default:
      break;
  }

  return filterData;
};

export const isEmptyObject = obj => {
  return !Object.values(obj)?.some(formVal => (Array.isArray(formVal) ? formVal?.length > 0 : !!formVal));
};
